<template>
    <div class="product-detail__yt">

        <a class="product-detail__yt-modal-btn" data-toggle="modal" :data-target="'#youtubeModal'+_cid" @click="playVideo">
            <lazy-img picture-class="product-detail__yt-thumbnail"
                      :image-url="'https://img.youtube.com/vi/'+videoId+'/0.jpg'"
                      alt="youtube Thumbnail">
            </lazy-img>
        </a>

        <div class="modal fade youtube-modal" :id="'youtubeModal'+_cid" tabindex="-1" aria-labelledby="youtubeModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $translate('OD3dprimaV2::Template.productVideos') }}</h5>
                        <button id="closeButtonYoutube" type="button" class="close" data-dismiss="modal" aria-label="Close" @click="stopVideo">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="embed-responsive embed-responsive-16by9" ref="iframe">
                            <iframe class="embed-responsive-item vue--lazy-img"
                                    :data-src="videoUrl"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen>
                            </iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {ComponentIdMixin} from "ceres/app/mixins/componentId.mixin";

export default {
    mixins: [
        ComponentIdMixin
    ],
    props: {
        videoId: {
            required: true
        }
    },
    data() {
        return {
            autoPlay: false
        }
    },
    computed: {
        videoUrl() {
            return 'https://www.youtube-nocookie.com/embed/' + this.videoId + '?controls=1' + (this.autoPlay ? '&autoplay=1' : '')
        }
    },
    methods: {
        playVideo() {
            this.autoPlay = true;
            this.updateSrc();
        },
        stopVideo() {
            this.autoPlay = false;
            this.updateSrc();
        },
        updateSrc() {

            //no data binding for src available because of lazy load (data-src to src)
            let iframe = this.$refs.iframe.querySelector('iframe');

            if(iframe && iframe.getAttribute('src')) {
                iframe.setAttribute('src', this.videoUrl);
            }
        }
    }
}
</script>
